var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"banner"}},[_c('van-swipe',{attrs:{"autoplay":60000,"duration":1500}},_vm._l((_vm.slides),function(item){return _c('van-swipe-item',{key:item.id},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(item.img),expression:"item.img"}],staticClass:"banner-img"})])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }